<template>
  <div class="soha-star-rating-wrapper d-flex align-items-center">
    <div
      class="stars-interactive-container position-relative"
      :class="{ 'ml-2': showScore }"
    >
      <div class="mirror-stars-container">
        <vue3-star-ratings
          :model-value="displayValue"
          :disable-click="true"
          :star-size="size"
          :step="0.01" 
          :inactive-color="inactiveColor"
          :active-color="activeColor"
          :show-control="false"
        />
      </div>

      <div
        v-if="!readonly"
        class="interactive-overlay"
        @mouseleave="hoverValue = null"
      >
        <div
          v-for="val in interactionSteps"
          :key="val"
          class="hover-zone"
          @mouseenter="hoverValue = val"
          @click="setValue(val)"
        />
      </div>
    </div>

    <span
      v-if="showScore"
      class="score-label font-weight-bold ml-2"
      :class="textClass"
    >
      {{ formattedScore }} از ۵
    </span>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import vue3StarRatings from "vue3-star-ratings";

const props = defineProps({
  modelValue: { type: [Number, String], default: 0 },
  readonly: { type: Boolean, default: false },
  size: { type: Number, default: 16 },
  step: { type: Number, default: 0.5 }, // میزان دقت کلیک (مثلاً 0.5 برای نیم‌ستاره)
  showScore: { type: Boolean, default: true },
  activeColor: { type: String, default: '#FFA800' },
  inactiveColor: { type: String, default: '#e4e6ef' },
  textClass: { type: String, default: 'text-primary font-size-sm' },
  hoverEffect: { type: Boolean, default: true } // پراپ جدید برای کنترل نمایش هاور
});

const emit = defineEmits(['update:modelValue', 'change']);

const internalValue = ref(Number(props.modelValue));
const hoverValue = ref(null);

// مقداری که در لحظه باید نمایش داده شود
const displayValue = computed(() => {
  // اگر افکت هاور فعال باشد و ماوس روی ستاره‌ای باشد، مقدار هاور نشان داده می‌شود
  // در غیر این صورت (یا در زمان خاموش بودن افکت)، فقط مقدار ثبت‌شده نمایش داده می‌شود
  if (props.hoverEffect && hoverValue.value !== null) {
    return hoverValue.value;
  }
  return internalValue.value;
});

// همگام‌سازی با والد
watch(() => props.modelValue, (newVal) => {
  internalValue.value = Number(newVal);
});

// تبدیل اعداد به فارسی و رُند کردن تا ۲ رقم اعشار
const formattedScore = computed(() => {
  // برای لیبل نمره، همیشه مقدار قطعی (internalValue) را نشان می‌دهیم یا مقدار نمایشی را؟
  // منطقی‌تر است که لیبل متنی هم مثل ستاره‌ها از displayValue پیروی کند
  const val = Number(displayValue.value || 0);
  const rounded = Math.round(val * 100) / 100;
  return rounded.toString().replace(/\d/g, x => '۰۱۲۳۴۵۶۷۸۹'[x]);
});

// تولید مناطق کلیک نامرئی بر اساس step
const interactionSteps = computed(() => {
  const steps = [];
  const totalSteps = 5 / props.step;
  for (let i = 1; i <= totalSteps; i++) {
    steps.push(i * props.step);
  }
  return steps; // خروجی: [0.5, 1, 1.5, 2, ..., 5]
});

// متد ثبت نمره در زمان کلیک
const setValue = (val) => {
  internalValue.value = val;
  emit('update:modelValue', val);
  emit('change', val);
};
</script>

<style scoped>
.soha-star-rating-wrapper {
  display: inline-flex;
  direction: rtl;
}

.stars-interactive-container {
  position: relative;
  display: inline-block;
}

/* کانتینر نمایشی (آینه شده) */
.mirror-stars-container {
  display: flex;
  align-items: center;
  transform: scaleX(-1); /* ستاره‌ها را برعکس می‌کند تا از راست پر شوند */
  direction: ltr !important;
}

/* ===================================================
   شبکه جادویی تشخیص ماوس (RTL)
   =================================================== */
.interactive-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  direction: rtl; /* باعث می‌شود بلوک 0.5 در منتهی‌الیه راست قرار بگیرد! */
  z-index: 10;
  cursor: pointer;
}

.hover-zone {
  flex: 1; /* تقسیم مساوی عرض بین بلوک‌های کلیک */
  height: 100%;
}

.score-label {
  white-space: nowrap;
  line-height: 1;
  margin-top: 2px;
  min-width: 3rem;
}

/* حذف استایل‌های مزاحم پکیج داخلی */
:deep(.vue3-star-ratings__wrapper) {
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
}
:deep(.vue3-star-ratings) {
  padding: 0 !important;
  margin: 0 !important;
}
</style>